import { gql } from '@apollo/client';

export const nswLessonAlignmentFragment = gql`
  fragment NswLessonAlignmentFragment on NswLessonAlignment {
    lessonAlignments {
      unitNumber
      lessonNumber
      lessonName
    }
    alignmentNote
  }
`;

export const lessonNswAlignmentFragment = gql`
  fragment LessonNswAlignmentFragment on Lesson {
    id
    nswLessonAlignment {
      ...NswLessonAlignmentFragment
    }
  }
  ${nswLessonAlignmentFragment}
`;

export const UPDATE_LESSON_NSW_ALIGNMENT = gql`
  mutation UpdateLessonNswAlignment($input: UpdateLessonNswAlignmentInput!) {
    updateLessonNswAlignment(input: $input) {
      ...LessonNswAlignmentFragment
    }
  }
  ${lessonNswAlignmentFragment}
`;
